module.exports = __webpack_public_path__ + "static/media/Vaishnodevi_realty.5dadb728.png";